import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

function ScorePercentDisplay(props) {
  return (
    <div>
      <div
        style={{
          width: "70%",
          height: "70%",
          display: "inline-block",
        }}
      >
        <CircularProgressbar
          value={props.curValue}
          maxValue={props.maxValue}
          counterClockwise
          strokeWidth={16}
          text={`${props.curValue}`}
          styles={buildStyles({
            textColor: "#07115A",
            pathColor: "#07115A",
            strokeLinecap: "butt",
          })}
        />
      </div>
      <h3>{props.chartType}</h3>
      (out of {props.maxValue})
    </div>
  );
}

export default ScorePercentDisplay;
